export default __webpack_public_path__ + "static/media/home.ab419dfd.jpg";